<template>
  <div class="page-container knowledge-assistant-page">
    <div class="header-section">
      <h5>Renox Assistant</h5>
      <p class="subtitle">Your friendly guide to Renox products, docs, and policies.</p>
    </div>

    <KnowledgeChatPanel variant="page" />
  </div>
</template>

<script>
import KnowledgeChatPanel from '@/components/cards/knowledge-chat/KnowledgeChatPanel.vue';

export default {
  name: 'KnowledgeAssistantPage',
  components: {
    KnowledgeChatPanel,
  },
};
</script>

<style scoped>
.knowledge-assistant-page {
  padding-bottom: 2rem;
}

.header-section {
  text-align: center;
  margin-bottom: 1.25rem;
}

.header-section h5 {
  margin: 0 0 0.35rem;
  font-size: 1.1rem;
  color: var(--text-primary);
}

.subtitle {
  margin: 0;
  font-size: 0.78rem;
  color: var(--text-tertiary);
}
</style>
